import React from 'react'
import { Form } from 'react-bootstrap'
import classNames from 'classnames'
import { CourseType } from 'enum'
import CheckBoxRadioButtonInput from 'components/ui/forms/field/checkbox-radiobutton/CheckBoxRadioButtonInput'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { prefix } from '../common'
import { Wrapper, Label, Title, Subtitle, Option } from './styled'

interface CourseTypeInputProps {
  value: CourseType
  onChange(value: CourseType): void
  error?: string
  disabled?: boolean
}

export const CourseTypeInput: React.FC<CourseTypeInputProps> = ({
  value,
  onChange,
  error,
  disabled,
}) => {
  const t = useTranslationRankmi({
    prefix: `${prefix}`,
  })

  const options = [
    {
      value: CourseType.Open,
      title: t('courseType.open.title'),
      subtitle: t('courseType.open.subtitle'),
    },
    {
      value: CourseType.Closed,
      title: t('courseType.close.title'),
      subtitle: t('courseType.close.subtitle'),
    },
  ]

  return (
    <Wrapper>
      <Form.Group>
        {options.map((option, index) => {
          const checked = value === option.value
          return (
            <Option key={index}>
              <CheckBoxRadioButtonInput
                name={'courseType-' + index}
                key={index}
                className={classNames(checked)}
                value={option.value}
                checked={checked}
                inline={true}
                type={'radio'}
                label={
                  <Label>
                    <Title>{option.title}</Title>
                    <Subtitle>{option.subtitle}</Subtitle>
                  </Label>
                }
                onChange={() => onChange(option.value)}
                error={error}
                disabled={disabled}
              />
            </Option>
          )
        })}
      </Form.Group>
    </Wrapper>
  )
}
